import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import BrowseServices from './pages/BrowseServices';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PostServiceModal from './components/PostServiceModal';

function App() {
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);

  return (
    <div className="app">
      <Header onPostService={() => setIsPostModalOpen(true)} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage onPostService={() => setIsPostModalOpen(true)} />} />
          <Route path="/browse" element={<BrowseServices onPostService={() => setIsPostModalOpen(true)} />} />
          <Route path="/browse/:category" element={<BrowseServices onPostService={() => setIsPostModalOpen(true)} />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>
      <Footer />

      {isPostModalOpen && (
        <PostServiceModal onClose={() => setIsPostModalOpen(false)} />
      )}
    </div>
  );
}

export default App;

